/**
 * 采集记录重构 fuck
 * date:2022 03 26 brian
 */

import httpRequest from '@/utils/request.js';

/**获取采集记录列表 */
export const carrierRecordList = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/carrierRecord/point/page',
        params: {
            ...params
        }
    });
/**获取采集记录审批状态 */
export const carrierRecordApproval = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/carrierRecord/point/approval',
        params: {
            ...params
        }
    });
/**获取采集记录状态 */
export const carrierRecordStatus = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/carrierRecord/point/status',
        params: {
            ...params
        }
    });
/**公共接口 */
export const carrierRecordDetail = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/share/param',
        params: {
            ...params
        }
    });
/**获取采集记录点分页 */
export const carrierRecordPage = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/carrierRecord/record/page',
        params: {
            ...params
        }
    });
/**根据范围获取设置 */
export const carrierDetail = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/carrierRecord/setting/detail',
        params: {
            ...params
        }
    });
/**获取采集单位 */
export const carrierUnit = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/carrierRecord/setting/unit',
        params: {
            ...params
        }
    });
/**获取采集点策略 */
export const carrierStrategy = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/share/collect/strategy',
        params: {
            ...params
        }
    });
/**批量审批 */
export const carrierUpdateBatch = data => httpRequest.httpPut2('/service/carrierRecord/point/updateBatch', data);
// 单条审批
export const carrierRecordUpdate = data => httpRequest.httpPut('/service/carrierRecord/point/update', data);
// 批量签名
export const carrierRecordupdateBatch = data => httpRequest.httpPut2('/service/carrierRecord/record/updateBatch', data);
// 单条签名
export const carrierUpdate = data => httpRequest.httpPut('/service/carrierRecord/record/update', data);
// 删除记录点
export const carrieDel = data => httpRequest.httpdelete('/service/carrierRecord/point/del', data);
// 导出记录点
export const carrieExport = (params = {}) => httpRequest.httpPost('/service/carrierRecord/point/export', params);
// 修改记录点
export const carrieSet = (params = {}) => httpRequest.httpPost('/service/carrierRecord/setting/set', params);
